import { type IIconProps } from './IIconProps';

interface IDownloadIconProps extends IIconProps {}

export default function Download({ color = '#000' }: IDownloadIconProps) {
  return (
    <svg viewBox="0 0 18 16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 9C0.6875 9 0 9.6875 0 10.5V14.5C0 15.3438 0.6875 16 1.5 16H16.5C17.3438 16 18 15.3438 18 14.5V10.5C18 9.6875 17.3438 9 16.5 9H13.625L15.0625 7.5625C16.0312 6.625 15.3438 5 14 5H12V1.5C12 0.6875 11.3438 0 10.5 0H7.5C6.6875 0 6 0.6875 6 1.5V5H4C2.6875 5 2 6.625 2.9375 7.5625L4.40625 9H1.5ZM14 6.5L9 11.5L4 6.5H7.5V1.5H10.5V6.5H14ZM1.5 14.5V10.5H5.90625L7.96875 12.5625C8.53125 13.1562 9.5 13.1562 10.0625 12.5625L12.125 10.5H16.5V14.5H1.5ZM4.25 12.5C4.25 12.0938 3.9375 11.75 3.5 11.75C3.09375 11.75 2.75 12.0938 2.75 12.5C2.75 12.9375 3.09375 13.25 3.5 13.25C3.9375 13.25 4.25 12.9375 4.25 12.5Z"
        fill={color}
      />
    </svg>
  );
}
